import omit from 'lodash/omit';
import { NewWatcherQueryParams } from '../../../watchers/watchers.types';
import { SearchParams } from '../../search.types';

export function getNewWatcherQueryParams(queryParams: NewWatcherQueryParams) {
  if (!queryParams.filterOnSpecificArticleVersion) {
    return omit(queryParams, [
      'lawArticleId',
      'filterOnSpecificArticleVersion',
    ]);
  }
  return queryParams;
}

export function getSnakeNewWatcherQueryParams(queryParams: SearchParams) {
  if (!queryParams.filter_on_specific_article_version) {
    return omit(queryParams, [
      'law_article_id',
      'filter_on_specific_article_version',
    ]);
  }
  return queryParams;
}
